import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../../components/AppIcon';
import Header from '../../components/ui/Header';
import Footer from '../landing-page/components/Footer';

const LegalPageLayout = ({ title, lastUpdated, children }) => (
  <div className="min-h-screen bg-gray-950 text-gray-100">
    <Header />
    <section className="pt-24 pb-12 px-4 sm:px-6 lg:px-8 bg-gradient-to-b from-gray-900 to-gray-950">
      <div className="max-w-4xl mx-auto">
        <div className="inline-flex items-center gap-2 bg-cyan-500/10 border border-cyan-500/20 rounded-full px-4 py-2 mb-6">
          <Icon name="FileText" size={16} className="text-cyan-400" />
          <span className="text-cyan-400 text-sm font-medium">Yasal Bilgiler</span>
        </div>
        <h1 className="text-3xl md:text-4xl font-bold text-white mb-3">{title}</h1>
        <p className="text-gray-500 text-sm">Son güncelleme: {lastUpdated}</p>
      </div>
    </section>
    <section className="py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto bg-gray-900 rounded-2xl p-8 md:p-12 border border-gray-800 prose prose-invert prose-sm max-w-none">
        {children}
      </div>
    </section>
    <div className="py-8 px-4 text-center">
      <div className="flex flex-wrap justify-center gap-4 text-sm">
        <Link to="/mesafeli-satis-sozlesmesi" className="text-gray-500 hover:text-cyan-400 transition-colors">Mesafeli Satış Sözleşmesi</Link>
        <Link to="/iptal-iade-kosullari" className="text-gray-500 hover:text-cyan-400 transition-colors">İptal ve İade Koşulları</Link>
        <Link to="/teslimat-politikasi" className="text-gray-500 hover:text-cyan-400 transition-colors">Teslimat Politikası</Link>
        <Link to="/kvkk-gizlilik-politikasi" className="text-gray-500 hover:text-cyan-400 transition-colors">KVKK ve Gizlilik Politikası</Link>
      </div>
    </div>
    <Footer />
  </div>
);

const Section = ({ title, children }) => (
  <div className="mb-8">
    <h2 className="text-xl font-bold text-white mb-3 pb-2 border-b border-gray-800">{title}</h2>
    <div className="text-gray-400 leading-relaxed space-y-3">{children}</div>
  </div>
);

export const MesafeliSatisSozlesmesi = () => (
  <LegalPageLayout title="Mesafeli Satış Sözleşmesi" lastUpdated="01 Nisan 2025">
    <Section title="1. Taraflar">
      <p><strong className="text-white">Satıcı:</strong><br />
      Unvan: Sıfır Noktası — Serhat ÇOKUÇKUN<br />
      Adres: Adalet Mah. Manas Blv. No: 47 B (Folkart Towers) İç Kapı No: 2601, Bayraklı / İZMİR<br />
      Telefon: +90 541 542 35 35<br />
      E-posta: info@paddleturkiye.com<br />
      Web: www.paddleturkiye.com (PaddleTurkiye — Sıfır Noktası'na ait tescilli bir markadır)</p>
      <p><strong className="text-white">Alıcı:</strong> Siteye kayıtlı ve sipariş veren kullanıcı.</p>
    </Section>
    <Section title="2. Sözleşmenin Konusu">
      <p>İşbu sözleşme, Alıcı'nın paddleturkiye.com üzerinden elektronik ortamda sipariş verdiği ürün/hizmetlerin satışı ve teslimatına ilişkin olarak 6502 sayılı Tüketicinin Korunması Hakkında Kanun ve Mesafeli Sözleşmeler Yönetmeliği hükümleri gereğince tarafların hak ve yükümlülüklerini düzenler.</p>
    </Section>
    <Section title="3. Ürün Bilgileri">
      <p>Sözleşme konusu ürün/hizmetin temel nitelikleri, satış fiyatı ve ödeme bilgileri sipariş sayfasında ve sipariş onay e-postasında yer almaktadır.</p>
    </Section>
    <Section title="4. Ödeme">
      <p>Ödeme, sipariş sırasında seçilen yöntemle (kredi kartı, banka havalesi vb.) gerçekleştirilir. Tüm fiyatlara KDV dahildir.</p>
    </Section>
    <Section title="5. Teslimat">
      <p>Ürünler, İzmir merkezli depomuzdan güvenle kargolanmaktadır. Teslimat süresi ve koşulları için Teslimat Politikamızı inceleyiniz.</p>
    </Section>
    <Section title="6. Cayma Hakkı">
      <p>Alıcı, ürünü teslim aldığı tarihten itibaren 14 (on dört) gün içinde herhangi bir gerekçe göstermeksizin ve cezai şart ödemeksizin sözleşmeden cayma hakkına sahiptir. Cayma bildirimi info@paddleturkiye.com adresine iletilmelidir.</p>
    </Section>
    <Section title="7. Uyuşmazlık Çözümü">
      <p>İşbu sözleşmeden doğan uyuşmazlıklarda İzmir Tüketici Hakem Heyetleri ve İzmir Mahkemeleri yetkilidir.</p>
    </Section>
  </LegalPageLayout>
);

export const IptalIadeKosullari = () => (
  <LegalPageLayout title="İptal ve İade Koşulları" lastUpdated="01 Nisan 2025">
    <Section title="Satıcı Bilgileri">
      <p>Sıfır Noktası — Serhat ÇOKUÇKUN<br />
      Adalet Mah. Manas Blv. No: 47 B (Folkart Towers) İç Kapı No: 2601, Bayraklı / İZMİR<br />
      info@paddleturkiye.com | +90 541 542 35 35</p>
    </Section>
    <Section title="1. Cayma Hakkı">
      <p>Tüketiciler, ürünü teslim aldıkları tarihten itibaren <strong className="text-white">14 gün</strong> içinde cayma hakkını kullanabilir. Bu süre içinde iade talebini info@paddleturkiye.com adresine iletmeniz yeterlidir.</p>
    </Section>
    <Section title="2. İade Koşulları">
      <p>İade edilecek ürünlerin:</p>
      <ul className="list-disc list-inside space-y-1 ml-2">
        <li>Kullanılmamış ve orijinal ambalajında olması,</li>
        <li>Tüm aksesuarları ve faturasıyla birlikte gönderilmesi,</li>
        <li>Hijyen bandı veya koruyucu folyosunun açılmamış olması gerekmektedir.</li>
      </ul>
    </Section>
    <Section title="3. İade Edilemeyen Ürünler">
      <ul className="list-disc list-inside space-y-1 ml-2">
        <li>Kişiye özel üretilen veya kişiselleştirilen ürünler</li>
        <li>Dijital içerikler ve etkinlik biletleri (etkinlik iptal edilmedikçe)</li>
        <li>Kullanılmış veya ambalajı açılmış hijyen ürünleri</li>
      </ul>
    </Section>
    <Section title="4. İptal Süreci">
      <p>Sipariş henüz kargoya verilmemişse, info@paddleturkiye.com adresine sipariş numaranızla başvurarak iptal talebinde bulunabilirsiniz. Kargoya verilen siparişler için iade prosedürü uygulanır.</p>
    </Section>
    <Section title="5. Para İadesi">
      <p>Onaylanan iadeler için ödeme iadesi, ürünün depomuzda teslim alınmasından itibaren <strong className="text-white">7 iş günü</strong> içinde ödeme yönteminize iade edilir.</p>
    </Section>
    <Section title="6. Etkinlik İptalleri">
      <p>Etkinlik iptalleri için etkinlik tarihinden en az 48 saat önce bildirim yapılması gerekmektedir. Geç iptal durumunda ücret iadesi yapılmayabilir.</p>
    </Section>
  </LegalPageLayout>
);

export const TeslimatPolitikasi = () => (
  <LegalPageLayout title="Teslimat Politikası" lastUpdated="01 Nisan 2025">
    <Section title="Satıcı Bilgileri">
      <p>Sıfır Noktası — Serhat ÇOKUÇKUN<br />
      Adalet Mah. Manas Blv. No: 47 B (Folkart Towers) İç Kapı No: 2601, Bayraklı / İZMİR<br />
      info@paddleturkiye.com | +90 541 542 35 35</p>
    </Section>
    <Section title="1. Kargo ve Gönderim">
      <p>Tüm ürünler, <strong className="text-white">İzmir merkezli depomuzdan</strong> özenle paketlenerek güvenli biçimde kargoya verilmektedir. Anlaşmalı kargo firmalarımız aracılığıyla Türkiye'nin her iline teslimat gerçekleştiriyoruz.</p>
    </Section>
    <Section title="2. Teslimat Süreleri">
      <ul className="list-disc list-inside space-y-2 ml-2">
        <li><strong className="text-white">Standart Teslimat:</strong> Sipariş onayından itibaren 2–5 iş günü</li>
        <li><strong className="text-white">İzmir İçi:</strong> 1–2 iş günü</li>
        <li><strong className="text-white">Uzak Bölgeler (Doğu Anadolu vb.):</strong> 4–7 iş günü</li>
      </ul>
      <p className="mt-3">Stokta bulunan ürünler aynı gün veya ertesi iş günü kargoya verilir. Stok dışı ürünler için tahmini süre ürün sayfasında belirtilir.</p>
    </Section>
    <Section title="3. Kargo Ücreti">
      <p>500 TL ve üzeri siparişlerde kargo ücretsizdir. Bu tutarın altındaki siparişlerde kargo ücreti sipariş özeti sayfasında gösterilir.</p>
    </Section>
    <Section title="4. Takip">
      <p>Siparişiniz kargoya verildikten sonra takip numarası e-posta ile iletilir. Siparişlerinizi hesabınızdaki "Sipariş Takibi" bölümünden de takip edebilirsiniz.</p>
    </Section>
    <Section title="5. Hasar ve Kayıp">
      <p>Kargo sırasında oluşan hasar veya kayıp durumunda, ürünü teslim almadan önce kargo görevlisi eşliğinde tutanak tutunuz ve info@paddleturkiye.com adresine bildirin. Hasarlı ürünler ücretsiz olarak değiştirilir.</p>
    </Section>
    <Section title="6. Uluslararası Gönderim">
      <p>Şu an için yalnızca Türkiye içi teslimat yapılmaktadır. Uluslararası gönderim talepleri için info@paddleturkiye.com adresinden iletişime geçiniz.</p>
    </Section>
  </LegalPageLayout>
);

export const KvkkGizlilikPolitikasi = () => (
  <LegalPageLayout title="KVKK ve Gizlilik Politikası" lastUpdated="01 Nisan 2025">
    <Section title="Veri Sorumlusu">
      <p>6698 sayılı Kişisel Verilerin Korunması Kanunu ("KVKK") kapsamında veri sorumlusu:<br />
      <strong className="text-white">Sıfır Noktası — Serhat ÇOKUÇKUN</strong><br />
      Adalet Mah. Manas Blv. No: 47 B (Folkart Towers) İç Kapı No: 2601, Bayraklı / İZMİR<br />
      info@paddleturkiye.com | +90 541 542 35 35</p>
    </Section>
    <Section title="1. Toplanan Kişisel Veriler">
      <ul className="list-disc list-inside space-y-1 ml-2">
        <li>Kimlik bilgileri (ad, soyad)</li>
        <li>İletişim bilgileri (e-posta, telefon, adres)</li>
        <li>Hesap ve işlem bilgileri</li>
        <li>Ödeme bilgileri (kart numarası saklanmaz)</li>
        <li>Kullanım verileri (IP adresi, çerezler)</li>
      </ul>
    </Section>
    <Section title="2. Kişisel Verilerin İşlenme Amaçları">
      <ul className="list-disc list-inside space-y-1 ml-2">
        <li>Sipariş ve teslimat süreçlerinin yürütülmesi</li>
        <li>Müşteri hizmetleri ve destek</li>
        <li>Yasal yükümlülüklerin yerine getirilmesi</li>
        <li>Pazarlama ve iletişim (açık rıza ile)</li>
        <li>Platform güvenliği ve dolandırıcılık önleme</li>
      </ul>
    </Section>
    <Section title="3. Kişisel Verilerin Aktarılması">
      <p>Kişisel verileriniz; kargo firmaları, ödeme kuruluşları ve yasal zorunluluklar kapsamında ilgili kamu kurumlarıyla paylaşılabilir. Üçüncü taraflarla veri paylaşımı KVKK hükümlerine uygun olarak gerçekleştirilir.</p>
    </Section>
    <Section title="4. Çerezler (Cookies)">
      <p>Sitemiz, kullanıcı deneyimini iyileştirmek amacıyla çerezler kullanmaktadır. Zorunlu çerezler hizmetin işleyişi için gereklidir; analitik ve pazarlama çerezleri için onayınız alınır.</p>
    </Section>
    <Section title="5. Haklarınız">
      <p>KVKK'nın 11. maddesi kapsamında aşağıdaki haklara sahipsiniz:</p>
      <ul className="list-disc list-inside space-y-1 ml-2">
        <li>Kişisel verilerinizin işlenip işlenmediğini öğrenme</li>
        <li>İşlenmişse bilgi talep etme</li>
        <li>İşlenme amacını ve amacına uygun kullanılıp kullanılmadığını öğrenme</li>
        <li>Yurt içinde veya yurt dışında aktarıldığı üçüncü kişileri bilme</li>
        <li>Eksik veya yanlış işlenmiş verilerin düzeltilmesini isteme</li>
        <li>Silinmesini veya yok edilmesini isteme</li>
        <li>İşlemeye itiraz etme</li>
      </ul>
      <p className="mt-3">Haklarınızı kullanmak için info@paddleturkiye.com adresine yazılı başvuruda bulunabilirsiniz.</p>
    </Section>
    <Section title="6. İletişim">
      <p>Gizlilik politikamıza ilişkin sorularınız için: info@paddleturkiye.com</p>
    </Section>
  </LegalPageLayout>
);
